<div id="pdp-rating-summary-stars" class="product-rating-summary" (click)="handleClick()">
    <span>
      <div data-bv-show="rating_summary" [attr.data-bv-product-id]="productPartNumber()"></div>
    </span>
</div>
